import React, { useState } from 'react';
import { PageLayout } from '~/common/components';
import { SearchViewModel } from './models';
import SearchBar from './components/search-bar';

import { SearchStore, useSearchStore } from './components/search-provider';
import SearchContents from './components/search-content';
import AIPreview from './components/ai-preview';
import AIPreviewErrorBoundary from './components/ai-preview/error-boundary';
import { AIPreviewState } from './components/ai-preview/types';

// AI Preview integration wrapper component
const AIPreviewIntegration: React.FC = () => {
  const {
    searchTerm,
    aiPreviewVisible,
    aiPreviewSessionId,
    aiPreviewState,
    aiPreviewError,
  } = useSearchStore();

  const handleError = (error: any) => {
    console.error('AI Preview Error:', error);
    // Error is automatically handled by the search store
    // Additional error tracking can be added here
  };

  const handleComplete = (response: any) => {
    console.log('AI Preview Complete:', response);
    // Response handling can be enhanced here if needed
  };

  const handleErrorBoundaryError = (error: any, errorInfo: any) => {
    console.error('AI Preview Error Boundary triggered:', { error, errorInfo });
    // Additional error boundary handling
    // Could trigger search store error state if needed
  };

  return (
    <AIPreviewErrorBoundary
      onError={handleErrorBoundaryError}
      fallback={
        <div
          role="alert"
          aria-live="assertive"
          style={{
            padding: '16px',
            margin: '16px 0',
            backgroundColor: '#f9fafb',
            border: '1px solid #e5e7eb',
            borderRadius: '8px',
            textAlign: 'center',
            color: '#6b7280',
          }}
        >
          <div style={{ marginBottom: '8px', fontWeight: 500 }}>
            AI Preview is temporarily unavailable
          </div>
          <div style={{ fontSize: '14px' }}>
            Your search results are still available below.
          </div>
        </div>
      }
    >
      <AIPreview
        searchQuery={searchTerm}
        isVisible={aiPreviewVisible}
        sessionId={aiPreviewSessionId || undefined}
        onError={handleError}
        onComplete={handleComplete}
        // Pass through loading states for enhanced UX
        isLoading={aiPreviewState === AIPreviewState.LOADING}
        // Add error props for better error handling
        mockError={aiPreviewError || undefined}
      />
    </AIPreviewErrorBoundary>
  );
};

const Search = (props: SearchViewModel) => {
  console.log('Search Props:', props);
  return (
    <div id="search-page">
      <SearchStore {...props}>
        <PageLayout>
          <SearchBar />
          <SearchContents />
        </PageLayout>
      </SearchStore>
    </div>
  );
};

export default Search;
